export const sortedNotificationSubsText = [
  { topic: 'fire', text: 'SortedEvent.Fire' },
  { topic: 'panic', text: 'SortedEvent.Panic' },
  { topic: 'tamper', text: 'SortedEvent.Tamper' },
  { topic: 'alarmTrigger', text: 'SortedEvent.AlarmTrigger' },
  { topic: 'expanderModule', text: 'SortedEvent.ExpModuleFailure' },
  { topic: 'zoneTamper', text: 'SortedEvent.PanelZoneTamper' },
  { topic: 'silentTheft', text: 'SortedEvent.SilentRobbery' },
  { topic: 'generalAlarm', text: 'SortedEvent.GeneralAlarm' },
  { topic: 'highTemperature', text: 'SortedEvent.HighTemp' },
  { topic: 'lowTemperature', text: 'SortedEvent.LowTemp' },
  { topic: 'hs24aux', text: 'SortedEvent.Zone24H' },
  { topic: 'medic', text: 'SortedEvent.MedEmergency' },
  { topic: 'sirenFailure', text: 'SortedEvent.SirenFailure'},
  { topic: 'zoneEnergyProblem', text: 'SortedEvent.ZoneEnergyProblem' },
  { topic: 'comunicationProblem', text: 'SortedEvent.ComFailure' },
  { topic: 'zoneLowBattery', text: 'SortedEvent.ZoneLowBattery' },
  { topic: 'sensorFailure', text: 'SortedEvent.SenFailure' },
  { topic: 'energyProblem', text: 'SortedEvent.EnergyConLost' },
  { topic: 'lowBattery', text: 'SortedEvent.LowBattery' },
  { topic: 'trouble', text: 'SortedEvent.Trouble' },
  { topic: 'systemShutdown', text: 'SortedEvent.SystReset' },
  { topic: 'systemProblem', text: 'SortedEvent.SystProblem' },
  { topic: 'armedStay', text: 'SortedEvent.ArmedStay' },
  { topic: 'resetPanicAlarm', text: 'SortedEvent.PanicReset' },
  { topic: 'armed', text: 'SortedEvent.Armed' },
  { topic: 'disarmed', text: 'SortedEvent.Disarmed' },
  { topic: 'bypassedZone', text: 'SortedEvent.CancelZone' },
  { topic: 'panelTest', text: 'SortedEvent.PanelTest' },
  { topic: 'panelTestError', text: 'SortedEvent.PanelTestError' },
  { topic: 'disarmRequiredMessage', text: 'SortedNotif.DisRequired' }
];
